import React from 'react'
import { getModuleDescription } from '../DataAndAPIs/ClassSections'
import { classProductPresentationLink } from '../Activities/ClassProduct'
import { sprintEndDateWithoutTime } from '../CalendarAndSchedule/SprintDates'
import { scheduleLinkV2 } from '../DataAndAPIs/Links'
import { getClassSectionID } from '../DataAndAPIs/ClassSections'

export const al49200Sprint08 = () => {
	const sprint = 8
	return ( <div>	
		<h5>Sprint {sprint}: {getModuleDescription(sprint-1)}</h5>
		<p>You made it. Very well done! Thank you for your dedication, support, and participation. Let’s finish 
		strong. It has been a sincere pleasure. </p>

		<p>All that’s left is to put the final touches on your product, verify that the product has been fully 
		transitioned, and jointly deliver your {classProductPresentationLink()} to your classmates and instructor.</p>

		{list49200Sprint08(sprint)}
	</div> )
}

export const list49200Sprint08 = (sprint) => {
	return ( <div>
		<p>Below is our activities list which, according to our {scheduleLinkV2(getClassSectionID(), sprint)}, needs to be 
		completed by {sprintEndDateWithoutTime(sprint-1)}:</p>
		<ol>
			<li>Finalize your {classProductPresentationLink()}</li>
			<li>Submit Lab 8 at least two hours prior to your scheduled presentation time</li>
			<li>Deliver your {classProductPresentationLink()} jointly with all product teams at the scheduled time</li>
			<li>Submit all assignments no later than {sprintEndDateWithoutTime(sprint-1)}</li>
		</ol>
	</div> )
}

// Certified for SP25 on April 17, 2025
// Review sprint 8 assignments particularly the Writing Assignment. The requested length of 750 words is too long, plus
//     it is not a very good assignment. 